import React from "react";

import {
    TerminalGroupConfiguration,
    GameGroupConfiguration,
    GROUP_TYPE, ProgressiveConfig
} from "../../reducers/editingConfiguration.reducer";
import { SelectedGroupsByProgressive } from "../../models/SelectedGroupsByProgressive";
import GameInstance from "../../models/GameInstance.model";
import getPhilippinesGames from "./find-ph-fbm-games";

/**
 * Returns a list of still available terminal or game groups, considering
 * the progressive type and group type.
 *
 * If group type is neither terminal or game, then an empty array is returned.
 *
 * @param existingTerminalGroups { TerminalGroupConfiguration[] }
 * @param selectedTerminalGroups { SelectedGroupsByProgressive }
 * @param existingGameGroups { GameGroupConfiguration[] }
 * @param selectedGameGroups { SelectedGroupsByProgressive }
 * @param progressiveType { string }
 * @param groupType { GROUP_TYPE }
 * @returns Array<{value: string | number, label: string}>
 */
export function parseAvailableGroups(
    existingTerminalGroups: TerminalGroupConfiguration[],
    selectedTerminalGroups: SelectedGroupsByProgressive,
    existingGameGroups: GameGroupConfiguration[],
    selectedGameGroups: SelectedGroupsByProgressive,
    progressiveType: string,
    groupType: GROUP_TYPE
): { value: string | number; label: string }[] {
    let existingIds;
    let typeKey =
        progressiveType == "fractionated" ||
        progressiveType == "multipots" ||
        progressiveType == "jumbolink" ||
        progressiveType == "luckytokenslink" ||
        progressiveType == "levels" ||
        progressiveType == "reelstrike" ||
        progressiveType == "easylink" ||
        progressiveType == "normal" ||
        progressiveType == "sap" ||
        progressiveType == "proportional"
            ? "progressive"
            : progressiveType;

    switch (groupType) {
        case GROUP_TYPE.TERMINAL:
            existingIds = selectedTerminalGroups[typeKey].map(
                (group: TerminalGroupConfiguration) => group.id
            );
            return existingTerminalGroups
                .filter(
                    (terminal: TerminalGroupConfiguration) =>
                        !existingIds.includes(terminal.id)
                )
                .map((terminal: TerminalGroupConfiguration) => ({
                    value: terminal.id,
                    label: terminal.name
                }));
        case GROUP_TYPE.GAME:
            existingIds = selectedGameGroups[typeKey].map(
                (group: GameGroupConfiguration) => group.id
            );
            return existingGameGroups
                .filter(
                    (group: GameGroupConfiguration) =>
                        !existingIds.includes(group.id)
                )
                .map((group: GameGroupConfiguration) => {
                    return {
                        value: group.id,
                        label: group.name
                    };
                });
        default:
            return [];
    }
}

export function parseAvailableGames(
    existingGameInstances: GameInstance[],
    selectedGameInstancesIds: number[]
): { value: string | number; label: any }[] {

    const GAME_TYPES = {
        0: "bingo",
        1: "spins",
        2: "lotto",
        3: "keno"
    };

    return existingGameInstances
        .filter(
            (game: GameInstance) =>
                !selectedGameInstancesIds.includes(game.identifier)
        )
        .map((game: GameInstance) => {
            return {
                value: game.identifier,
                label: game.description,
                appendex: GAME_TYPES[game.game.type]
            };
        });
}

export function checkProgressivesHaveGroups(progressivesConfigs: ProgressiveConfig[], groupType: string) {
    let haveGroups = false;
    haveGroups = progressivesConfigs.some(item => {
        if (
            item.type == "levels" ||
            item.type == "easylink" ||
            item.type == "sap" ||
            item.type == "multipots" ||
            item.type == "jumbolink" ||
            item.type == "reelstrike" ||
            item.type == "luckytokenslink"
        ) {
            if (
                item[groupType] &&
                item[groupType].length > 0
            ) {
                return true;
            } else {
                let childrenHaveGroups = false;
                item["children"].map(child => {
                    if (child[groupType] &&
                        child[groupType].length > 0)
                        childrenHaveGroups = true
                });

                return childrenHaveGroups;
            }
        } else {
            return item[groupType] &&
                item[groupType].length > 0
        }
    });
    return haveGroups
}
